export default __webpack_public_path__ + "static/media/Ontraccr-Fav-B-300x300.4a44ed6a.png";